import { selectSmimeActions } from "../selectors";
import { FieldFormat, SectionConfig } from "../../types";
import { getItemKeyByValue } from "./helpers";

const SMIME_ACTION: FieldFormat = {
  enum: {
    ENCRYPT: "smimeAction.ENCRYPT.label",
    DECRYPT: "smimeAction.DECRYPT.label",
    VALIDATE: "smimeAction.VALIDATE.label",
    SIGN: "smimeAction.SIGN.label",
  },
};

const config: SectionConfig = {
  section: "smimeActions",
  titleKey: "confirmRuleUpdates.smimeActionChanges.title",
  selector: selectSmimeActions,
  properties: {
    smimeActions: {
      label: "confirmRuleUpdates.smimeActions.label",
      format: SMIME_ACTION,
      getItemKey: getItemKeyByValue,
    },
    addSubjectInvalidSmime: {
      label: "smime.enableFailedAction.label",
      format: "boolean",
    },
    subjectInvalidSmime: { label: "smime.invalidSubject.label" },
  },
};

export default config;
